import type {
  JSTPaywallDisplayStyle,
  JSTPaywallResult,
} from "../../shared/native-modules/types/TareBridge";

import { getTareBridge } from "../../shared/native-modules/tare/getTareBridge";

export async function openPaywallModal({
  style,
  from,
  tk,
}: {
  style: JSTPaywallDisplayStyle;
  from?: string;
  tk?: string;
}): Promise<JSTPaywallResult> {
  const tareBridge = getTareBridge();
  if (tareBridge?.openPaywallModal) {
    return await tareBridge.openPaywallModal(style, from, tk);
  }
  return {
    paywallScreenResult: "FAILURE",
  };
}
